import React, { useContext, useState } from "react";
import { ThemeContext } from "styled-components";
import { Redirect } from "react-router-dom";
import { I18n } from "aws-amplify";
import {
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Input,
  InputLabel,
  Button,
  FormField,
  Link,
  SectionFooterPrimaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

import { updateUserEmail } from "../../api/SiteApi";
import { useAuthContext } from "./AuthContext";
import { AuthNavHome } from "./AuthNavHome";
import authenticatorConfig from "./authenticatorConfig";

const UserSettingsPage = () => {
  const [email, setEmail] = useState("");
  const { isAuthenticated, signOut } = useAuthContext();
  const siteTheme = useContext(ThemeContext);
  const { theme } = authenticatorConfig(siteTheme);

  const updateEmail = async () => {
    try {
      await updateUserEmail(email);
      alert("Successfully updated your email.");
    } catch (err) {
      alert("There was an issue updating your email.");
    }
  };

  if (!isAuthenticated) return <Redirect to="/auth" />;

  return (
    <>
      <AuthNavHome theme={theme} />
      <div style={{ marginTop: 56 }}>
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>
            {I18n.get("User Settings")}
          </SectionHeader>
          <SectionBody theme={theme}>
            <FormField theme={theme}>
              <InputLabel theme={theme}>{I18n.get("Update Email")}</InputLabel>
              <Input
                placeholder={I18n.get("Enter new email")}
                theme={theme}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </FormField>
          </SectionBody>
          <SectionFooter theme={theme}>
            <SectionFooterPrimaryContent theme={theme}>
              <Button theme={theme} onClick={updateEmail}>
                {I18n.get("Change Email")}
              </Button>
            </SectionFooterPrimaryContent>
          </SectionFooter>
        </FormSection>
        <div style={{ textAlign: "center", margin: "-36px 0 48px", zIndex: 1 }}>
          <Link theme={theme} onClick={signOut}>
            {I18n.get("Sign Out")}
          </Link>
        </div>
      </div>
    </>
  );
};

export default UserSettingsPage;
